export default {"src":"/_next/static/media/HTZ.79368b58.svg","height":18,"width":18};